import React, { useState } from "react";
import { Alert } from "@mui/material";
import OverwatchModal from "@/components/OverwatchModal";
import { BulkImportUsersDocument } from "@/graphql/generated/graphql";
import useDirectUpload from "@/hooks/useDirectUpload";
import { StyledDropzone } from "@/theme/styled-components";
import { displayNotification } from "@/utils/notifications";
import { useMutation } from "@apollo/client/react";
import { FileMosaic } from "@files-ui/react";

interface CreateEquipmentModalProps {
  handleClose: () => void;
}
const UploadUsersModal: React.FC<CreateEquipmentModalProps> = ({
  handleClose,
}) => {
  // this was supposed to be ExtFile[] but ExtFile is not working for some reason.
  const [files, setFiles] = useState<any[]>([]);
  const { isUploading, uploadFile, error } = useDirectUpload();
  const [bulkImport, { loading }] = useMutation(BulkImportUsersDocument, {
    onCompleted: () => {
      displayNotification({
        type: "success",
        text: "People imported successfully!",
      });
      handleClose();
    },
    onError: () => {
      displayNotification({
        type: "error",
        text: "Unable to import people from the CSV. Try again later.",
      });
    },
    refetchQueries: ["getEmployees"],
  });

  const handleFileChange = (files: []) => {
    setFiles(files);
  };
  const handleSubmit = () => {
    if (files) {
      uploadFile(files[0].file as File, "imports/users")
        .then((response) => {
          bulkImport({
            variables: { fileSignedId: response?.signedBlobId as string },
          });
        });
    }
  };
  const removeFile = (id: string | number | undefined) => {
    setFiles(files.filter((x) => x.id !== id));
  };

  const handleTertiaryClick = () => {
    window.open("https://resources-management.s3.eu-west-2.amazonaws.com/user_upload_sample.csv", "_blank")
  }


  return (
    <OverwatchModal
      size="sm"
      title="Bulk Upload People"
      caption="Add people in bulk using a CSV"
      handleClose={handleClose}
      primaryButtonAction={handleSubmit}
      primaryButtonText={isUploading ? "Uploading..." : loading ? "Importing..." : "Upload"}
      disablePrimary={!files.length || isUploading || loading}
      tertiaryButtonText="Download Sample CSV"
      tertiaryButtonAction={handleTertiaryClick}
    >
      <StyledDropzone
        onChange={handleFileChange}
        value={files}
        accept=".csv"
        maxFiles={1}
        header={false}
        footer={false}
      >
        {files.map((files) => (
          <FileMosaic key={files.id} {...files} onDelete={removeFile} info />
        ))}
      </StyledDropzone>

      {error && <Alert severity="error" sx={{ mt: 1 }}>{error}</Alert>}
    </OverwatchModal>
  )
};

export default UploadUsersModal;
